/* eslint-disable jsx-a11y/anchor-is-valid */

import { AuditOutlined, DownOutlined, ExportOutlined, SmileOutlined } from '@ant-design/icons';
import { Avatar, Button, Dropdown, Space } from 'antd';

import React from 'react';
import { useAuth } from '../../hooks/useAuth';

const Profile = () => {


    const { logout } = useAuth();

    const items = [
        {
            key: '1',
            label: (
                <a rel="noopener noreferrer" href="/profile">
                    Dados Pessoais
                </a>
            ),
            icon: <AuditOutlined />
        },
        {
            key: '2',
            label: (
                <Button
                    type="ghost"
                    onClick={() => {
                        logout()
                    }}
                >
                    Sair
                </Button>
            ),
            icon: <ExportOutlined style={{ color: 'red' }} />,
        },

    ];





    return (
        <Dropdown menu={{ items }}>

            <Avatar
                onClick={(e) => e.preventDefault()}
                size={40}
                src={"https://www.w3schools.com/w3images/avatar2.png"}
                onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "https://www.w3schools.com/w3images/avatar2.png";
                }}
            />
            
        </Dropdown>
    )
}



export default Profile;